import React from "react";
import { Image, Icon, Menu, Dropdown, Loader, Header } from "semantic-ui-react";
import { Link } from "react-router-dom";

const UserAvatar = ({ user }) => {
  return (
    <>
      <Image
        src={
          user?.image ||
          "https://react.semantic-ui.com/images/wireframe/square-image.png"
        }
        avatar
      />
    </>
  );
};

function TopNav({ item, user, handleModal, handleClick, schoolId }) {
  return (
    <>
      <Menu borderless>
        <Menu.Menu position='left'>
          <Menu.Item>
            <Header
              as='h4'
              content={
                `${item && item.substr(0, 1).toUpperCase()}${
                  item && item.substr(1)
                }` || "Home"
              }
            />
          </Menu.Item>
        </Menu.Menu>
        <Menu.Menu position='right'>
          <Menu.Item>
            <Icon name='bell outline' size='large' />
          </Menu.Item>

          <Menu.Item name='help'>
            {!user ? (
              <Loader active size='tiny' />
            ) : (
              <>
                <UserAvatar user={user} />
                <Dropdown inline text={`${user.firstName} ${user.lastName}`}>
                  <Dropdown.Menu>
                    <Link to={`/dashboard/s/${schoolId}/u/edit`}>
                      <Dropdown.Item
                        icon='pencil'
                        content='Edit Profile'
                        name='Edit Profile'
                        onClick={handleClick}
                      />
                    </Link>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      icon={<Icon color='red' name='trash' />}
                      content={
                        <span color='red' className='text-danger'>
                          Delete Account
                        </span>
                      }
                      onClick={() => handleModal(false)}
                    />
                  </Dropdown.Menu>
                </Dropdown>
              </>
            )}
          </Menu.Item>
        </Menu.Menu>
      </Menu>
    </>
  );
}

export default TopNav;
